import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useTransactionsGetById } from 'core/types'

import ModelLink from './ModelLink'

type TransactionLinkProps = {
  transactionId: string
}

const TransactionLink: FC<TransactionLinkProps> = ({ transactionId }) => {
  const [_, { personId, loanId }] = useQueryApi()
  const { data: transaction, isLoading } = useTransactionsGetById({
    personId,
    loanId,
    transactionId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  return (
    <ModelLink id={transactionId} isLoading={isLoading} model={transaction} />
  )
}

export default TransactionLink
